'use client';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="ru">
      <body style={{ fontFamily: 'sans-serif', padding: 24 }}>
        <h2>Что-то пошло не так</h2>
        <p style={{ color: '#dc2626', whiteSpace: 'pre-wrap' }}>{error?.message || 'Неизвестная ошибка'}</p>
        {error?.stack && <pre style={{ maxHeight: 300, overflow: 'auto', whiteSpace: 'pre-wrap', background: '#f4f4f5', padding: 12, fontSize: 11 }}>{error.stack}</pre>}
        <button onClick={() => reset()} style={{ marginTop: 12 }}>Повторить</button>
      </body>
    </html>
  );
}
